import React, { FC } from "react"
import { RouteComponentProps } from '@reach/router';
import { getEntity } from './wholesale.reducer';
import { connect } from 'react-redux';
import DetailsPage, { DetailsStateAndDispatchProps } from "layouts/page-wraper/details-page";
import { RootState } from "reducers";
import ProDescriptions from "@ant-design/pro-descriptions";
import { WholesaleProduct } from "model/product/wholesale-product.model";

export interface WholesaleProductDetailsProps extends DetailsStateAndDispatchProps<WholesaleProduct>,
  RouteComponentProps, StateProps, DispatchProps {
}
const WholesaleProductDetails: FC<WholesaleProductDetailsProps> = (props) => {
  return (
    <DetailsPage<WholesaleProduct>
      title={'商品详情'}
      hideEdit={true}
      {...props}
    >
      <ProDescriptions<WholesaleProduct>
        columns={props.columns as any}
        dataSource={props.entity}
        column={2}
      >
      </ProDescriptions>
    </DetailsPage>);
};

const mapStateToProps = ({ wholesaleProduct }: RootState) => ({
  entity: wholesaleProduct.entity,
});

const mapDispatchToProps = {
  getEntity,
};

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(mapStateToProps, mapDispatchToProps)(WholesaleProductDetails);
